import { useEffect, useState } from "react";
import { Keyboard } from "@capacitor/keyboard";
import { Capacitor } from "@capacitor/core";

/**
 * Hook to detect if the software keyboard is visible.
 * Uses native Capacitor Keyboard events which are more robust than viewport measurements.
 */
export function useIsKeyboardVisible() {
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);

  useEffect(() => {
    // Only applies to native platforms (Android/iOS)
    if (Capacitor.getPlatform() === "web") {
      return;
    }

    const showListener = Keyboard.addListener("keyboardWillShow", () => {
      setIsKeyboardVisible(true);
    });

    const hideListener = Keyboard.addListener("keyboardWillHide", () => {
      setIsKeyboardVisible(false);
    });

    return () => {
      void showListener.then((l) => l.remove());
      void hideListener.then((l) => l.remove());
    };
  }, []);

  return isKeyboardVisible;
}
